import { useStore } from 'utils/hooks/store';
import { useEditorStore } from 'containers/Tiptap/hooks/useEditorStore';
import { DocumentVariables } from 'containers/Tiptap/lib/header-footer-variables';

const FALLBACK_DOCUMENT_NAME = 'document';

export function useDocumentName(): string {
  const { documentsDetails } = useStore();
  const { details } = documentsDetails;

  return (details && documentsDetails.getName(details)) || FALLBACK_DOCUMENT_NAME;
}

export function useDocumentVariables(): DocumentVariables {
  const documentName = useDocumentName();
  const editorStore = useEditorStore();

  return {
    documentName,
    documentVersion: String(editorStore.snapshotState.latestVersion),
  };
}
